import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const boxShadow = "rgba(200, 200, 200, 0.4) 0px 1px 8px 0px";

const ShadowBox = styled(Box)(({ theme }) => ({
  boxShadow: boxShadow,
  borderRadius: 8, 
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  //border: `1px solid #f0f0f0`,
}));

export function getBoxShadow() {
  return boxShadow;
}

export default ShadowBox;